import { httpCreate } from './http';

const http = httpCreate('/srv/rainParticipant');

export const rainParticipant = {
	doVerdict(id, formData) {
		return http.post(`/doVerdict/${id}`, formData);
	},
	participantList(rainActivityId, params) {
		return http.get(`/participantList/${rainActivityId}`, { params });
	},
	guessList(rainActivityId, params) {
		return http.get(`/guess/${rainActivityId}`, { params });
	},
};
